export enum MessageState {
  Unread,
  Replied,
  Resolved,
  NoActionNeeded,
}
